import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import AssessmentScore from './AssessmentScore';

const useStyles = makeStyles((theme: Theme) => {
  return {
    legend: {
      display: 'flex',
      padding: theme.spacing(2),
    },
    dFlex: {
      display: 'flex',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingRight: theme.spacing(4),
    },
  };
});

const AssessmentScoreLegend = () => {
  const classes = useStyles();

  return (
    <div className={classes.legend}>
      <div className={classes.dFlex}>
        <AssessmentScore score={3} showLabel={true} />
      </div>
      <div className={classes.dFlex}>
        <AssessmentScore score={2} showLabel={true} />
      </div>
      <div className={classes.dFlex}>
        <AssessmentScore score={1} showLabel={true} />
      </div>
      <div className={classes.dFlex}>
        <AssessmentScore score={null} showLabel={true} />
      </div>
    </div>
  );
};

export default AssessmentScoreLegend;
